import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Megaphone, LifeBuoy, Home, MapPin, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { Page } from "@/components/shared";

export default function RoadDay() {
  const nav = useNavigate();
  const [sp, setSp] = useState([]);

  useEffect(() => {
    api.get("/safe-points").then(({ data }) => {
      setSp(data);
      localStorage.setItem("cs_cache_safepoints", JSON.stringify(data));
    }).catch(() => {
      const c = localStorage.getItem("cs_cache_safepoints");
      if (c) setSp(JSON.parse(c));
    });
  }, []);

  const actions = [
    { icon: Users, title: "MY CREW", sub: "Find. Share. Check in.", to: "/app/crew", color: "var(--cs-magenta)", t: "my-crew" },
    { icon: Megaphone, title: "BAND", sub: "Live Updates", to: "/app/updates", color: "var(--cs-blue)", t: "band" },
    { icon: LifeBuoy, title: "I NEED HELP", sub: "Get Support", to: "/app/help", color: "var(--cs-amber)", t: "help" },
    { icon: Home, title: "GET HOME", sub: "Safe Ride Options", to: "/app/get-home", color: "var(--cs-green)", t: "get-home" },
  ];

  return (
    <Page className="px-5 pt-6" >
      <button data-testid="road-day-exit" onClick={() => nav("/app")} className="cs-tap flex items-center gap-1 text-sm" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Home
      </button>

      <div className="text-center mt-4">
        <h1 className="font-head font-extrabold text-4xl tracking-tight">ROAD DAY MODE</h1>
        <p className="mt-2 text-base" style={{ color: "var(--cs-fg2)" }}>Stay connected. Look out for each other.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-6">
        {actions.map((a) => (
          <button key={a.t} data-testid={`road-day-grid-${a.t}-button`} onClick={() => nav(a.to)}
            className="cs-tap rounded-3xl flex flex-col items-center justify-center text-center p-4"
            style={{
              minHeight: 150,
              background: "linear-gradient(160deg, var(--cs-card-hi), var(--cs-card))",
              border: `2px solid ${a.color}`,
            }}>
            <a.icon size={40} style={{ color: a.color }} />
            <p className="font-head font-extrabold text-xl mt-3 leading-none">{a.title}</p>
            <p className="text-xs mt-1.5" style={{ color: "var(--cs-fg2)" }}>{a.sub}</p>
          </button>
        ))}
      </div>

      <div className="mt-6">
        <p className="text-xs font-bold tracking-wide mb-2 flex items-center gap-1.5" style={{ color: "var(--cs-fg2)" }}>
          <MapPin size={14} /> SAFE POINTS NEARBY
        </p>
        <div className="flex gap-3 overflow-x-auto no-scrollbar pb-2">
          {sp.slice(0, 4).map((s) => (
            <button key={s.id} data-testid={`road-day-safe-point-${s.id}`} onClick={() => nav("/app/safe-points")}
              className="cs-card cs-tap flex-shrink-0 p-3 text-left" style={{ minWidth: 160 }}>
              <p className="font-semibold text-sm leading-tight">{s.name}</p>
              <p className="text-xs mt-1" style={{ color: "var(--cs-green)" }}>{s.distance_km} km away</p>
            </button>
          ))}
        </div>
      </div>
    </Page>
  );
}
